import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
import {
  dodaqBg,
  dodaqBgHome,
  glitterBgHome,
  highlighterBgHome,
  kiprikBgHome,
  makyajAletleriBgHome,
  makyajTemizleyiciBgHome,
  mukemmelBitirisKolleksiyasiBgHome,
  qasSabitleyiciBgHome,
  services1,
  services2,
  services3,
  servicesArrow,
  servicesVector,
  tonalKremBgHome,
  transparanPudraBgHome,
} from "../../../assets/images";

const Categories = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  const newsItems = [
    {
      id: 1,
      imgSrc: dodaqBgHome,
      title: "Dodaq Boyaları",
      path: "products?categories=Dodaq Boyaları",
    },
    {
      id: 2,
      imgSrc: kiprikBgHome,
      title: "Kipriklər",
      path: "products?categories=Kipriklər",
    },
    {
      id: 3,
      imgSrc: mukemmelBitirisKolleksiyasiBgHome,
      title: "Mükəmməl Bitiriş Kolleksiyası",
      path: "products?categories=Mükəmməl Bitiriş Kolleksiyası",
    },
    {
      id: 4,
      imgSrc: qasSabitleyiciBgHome,
      title: "Qaş sabitləyici",
      path: "products?categories=Qaş sabitləyici",
    },
    {
      id: 5,
      imgSrc: makyajTemizleyiciBgHome,
      title: "Makyaj təmizləyici vasitələr",
      path: "products?categories=Makyaj təmizləyici vasitələr",
    },
    {
      id: 6,
      imgSrc: glitterBgHome,
      title: "Glitter",
      path: "products?categories=Glitter",
    },
    {
      id: 7,
      imgSrc: tonalKremBgHome,
      title: "Tonal krem",
      path: "products?categories=Tonal krem",
    },
     {
      id: 8,
      imgSrc: transparanPudraBgHome,
      title: "Transparan pudra",
      path: "products?categories=Transparan pudra",
    },
      {
      id: 9,
      imgSrc: makyajAletleriBgHome,
      title: "Makyaj alətləri",
      path: "products?categories=Makyaj alətləri",
    },
      {
      id: 10,
      imgSrc: highlighterBgHome,
      title: "Highlighter",
      path: "products?categories=Highlighter",
    },
  ];

  return (
    <div className="pt-10 md:pt-20">
      <div className="max-w-containerSm md:max-w-container mx-auto">
        <div className="md:flex justify-between">
          <div className="md:w-[430px]">
            <p className="text-[24px] md:text-[32px] font-semibold text-[#181D27]">
              {t("Gözəlliyinizi Tamamlayan Kateqoriyalar")}
            </p>
            <p className="text-[14px] md:text-[16px] text-[#181D27] mt-4">
              {t(
                "Dodaq boyalarından peşəkar makiyaja qədər, hər zövqə uyğun seçimlər sizi gözləyir."
              )}
            </p>
            <div className="flex justify-end mt-3 md:mt-8">
              <img className="w-[80px] md:w-[320px]" src={servicesVector}></img>
            </div>
          </div>
          <div className="mt-10 md:mt-0 md:w-[820px]">
            <Swiper
              spaceBetween={40} // 👈 daha fazla boşluk 
              loop={true}
              pagination={{ clickable: true }}
              navigation={{
                nextEl: ".swiper-button-next-custom2",
                prevEl: ".swiper-button-prev-custom2",
              }}
              autoplay={{
                delay: 1000,
                disableOnInteraction: false,
              }}
              modules={[Pagination, Navigation, Autoplay]}
              breakpoints={{
                480: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                768: { slidesPerView: 2.2 },
                1024: { slidesPerView: 2.3 }, // 👈 3. slaytın birazı görünür
              }}
            >
              {newsItems.map((item) => (
                <SwiperSlide key={item.id}>
                  <a href={`/${currentLanguage}/${item.path}`}>
                    <div className="relative h-[372px] md:h-[440px] group overflow-hidden rounded-lg">
                      <img
                        src={item.imgSrc}
                        className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                        alt=""
                      />
                      <div className="absolute bottom-0 w-full flex items-center justify-between h-[72px] md:h-[84px] py-3 px-9 bg-black/50 backdrop-blur-md text-white text-[18px] md:text-[20px] font-medium">
                        <p>{t(item.title)}</p>
                        <img className="w-6 h-6" src={servicesArrow}></img>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
